import { ref, onMounted } from "vue"

import BzbsAddress from "@/core/Address/service/BzbsAddress"

export const countryListWithLocales = {
    1033: [
        { text: "+86", name: "China", altValue: "China" },
        { text: "+852", name: "Hongkong", altValue: "Hongkong" },
        { text: "+81", name: "Japan", altValue: "Japan" },
        { text: "+66", name: "Thailand", altValue: "Thailand" },
        { text: "+82", name: "Korea", altValue: "Korea" },
        { text: "+886", name: "Taiwan", altValue: "Taiwan" },
        { text: "+65", name: "Singapore", altValue: "Singapore" },
    ],
    1054: [
        { text: "+86", name: "จีน", altValue: "China" },
        { text: "+852", name: "ฮ่องกง", altValue: "Hongkong" },
        { text: "+81", name: "ญี่ปุ่น", altValue: "Japan" },
        { text: "+66", name: "ไทย", altValue: "Thailand" },
        { text: "+82", name: "เกาหลี", altValue: "Korea" },
        { text: "+886", name: "ไต้หวัน", altValue: "Taiwan" },
        { text: "+65", name: "สิงคโปร์", altValue: "Singapore" },
    ]
}

export default function useAvailableRegion(localeCode) {
    const countryList = ref([])

    const getCountryList = () => {
        /**@type Array */
        let list = countryListWithLocales[localeCode]
        countryList.value = list.map(x => {
            return {
                value: x.text.replace("+", ""),
                ...x
            }
        })
    }

    onMounted(getCountryList)

    return {
        countryList,
    }
}

export function useProvinceDropdownList() {
    const provinceList = ref([])

    /**
     *
     * @returns {Promise}
     */
    const getProvinceList = () => {
        return new Promise((resolve, reject) => {
            BzbsAddress.apiGetProvince().subscribe({
                next: (data) => {
                    provinceList.value = data
                    resolve(data)
                },
                error: (err) => {
                    provinceList.value = []
                    reject(err)
                }
            })
        })
    }

    onMounted(getProvinceList)

    return {
        provinceList,
        getProvinceList
    }
}
